import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import AppContainer from "../AppContainer/AppContainer";
import {Link} from "react-router-dom";

import "./quality-check.scss";
import useAppState from "../../common/StateMachine/useAppState";
import { useTranslation } from "react-i18next";

const CollectorQualityCheck = props => {
    const jobState = useAppState("jobs");
    const [correctPlastic, setCorrectPlastic] = useState(false);
    const [correctLocation, setCorrectLocation] = useState(false);
    const jobDetail = jobState.state.jobDetail;
    const {plasticType} = jobDetail;
    const [t] = useTranslation();

    function toggleCorrectPlastic() {
        setCorrectPlastic(!correctPlastic);
    }
    function toggleCorrectLocation() {
        setCorrectLocation(!correctLocation);
    }

    useEffect(() => {
        jobState.getJob(props.match.params.jobId);
    }, []);
    
    return (
        <AppContainer>
            <div class="formContainer">
                <div class="formObject withBorder title">{t("verifyQualityControl")}</div>
                <div class="formObject">{t("jobNum")}{jobDetail.id}</div>
                <div class="formObject withBorder">{t(plasticType.name)}</div>
                <div class="formObject">
                    <div className={"checkbox"}>
                        <i onClick={toggleCorrectPlastic} className={"fal " + (correctPlastic ? "fa-check-square" : "fa-square")}></i>
                    </div>
                    <div class="checkboxLabel">{t("areYouDeliveringTheRightPlastic")}</div>
                </div>
                <div class="formObject">{t("collectionSites")}</div>
                <div class="formObject column">
                    <ul>
                        {
                            jobDetail.assignedSites.map(site => <li class="formSubObject">{site.name}</li>)
                        }
                    </ul>
                </div>
                <div class="formObject">
                    <div className={"checkbox"}>
                        <i onClick={toggleCorrectLocation} className={"fal " + (correctLocation ? "fa-check-square" : "fa-square")}></i>
                    </div>
                    <div class="checkboxLabel">{t("areYouDeliveringToTheRightHub")}</div>
                </div>
                <Link className={((correctLocation && correctPlastic) ? "activeLink" : "inactiveLink")} to={`/jobs/job-delivery/${props.match.params.jobId}`}>
                <div className={"acceptButton centred withBorder " + ((correctLocation && correctPlastic) ? "accept" : "disabled")}>{t("okToLog")}</div>
                </Link>
            </div>
        </AppContainer>
    );
}

export default withRouter(CollectorQualityCheck);